<div class="menu-tabs"
		 [class.active]="active"
		 [class.border-on-right]="borderSide === 'right'"
		 [class.border-on-left]="borderSide === 'left'">
	<p class="menu-tabs-title">{{title}}</p>
	<div class="menu-tabs-icon"
			 [class.formations]="selectedTab === 'formations'"
			 [class.reservations]="selectedTab === 'reservations'"></div>
</div>
